import { isDate } from 'lodash';

import { ValidationFunction } from '@/common/validation';

export const dateRequired: ValidationFunction = (value, [checkboxValue]) => {
	const isValid = isDate(value) || checkboxValue === true;

	return isValid || 'Field is required';
};
